import { useState, useEffect, useRef } from 'react'
import { t } from '@/utils/i18n'
import styles from './index.module.less'
import { utils, apis } from '@/utils'
import ProductCell1688 from '@/pages/Products1688/components/ProductCell'
import Masonry from 'react-masonry-css'
import { InfiniteScroll, DotLoading } from 'antd-mobile' // List
import useRefState from '@/hooks/useRefState'
import noDataImg from '@/assets/img/default/empty_list.jpg'

const { to, px2rem } = utils
const { thirdApi } = apis

interface IProps {
  searchText?: string
  imageId?: string
  country?: string
  filter?: any
}

const Products = (props: IProps) => {
  const { searchText, imageId, country, filter } = props
  const [productList, setProductList] = useState([])
  const [pageLoading, setPageLoading] = useState(false)
  const [extend, setExtend] = useState({
    currency: '￥',
    exchangeRate: 1,
    decimalPlace: 2,
  })
  const [cellWidth, setCellWidth] = useState('')
  const refMasonry = useRef<HTMLDivElement | null>(null)
  const [hasMore, setHasMore] = useState(false)
  const [noData, setNoData] = useState(false)
  const [pageNum, setPageNum, pageNumRef] = useRefState(1)

  const breakpointColumnsObj = {
    default: 2,
  }

  useEffect(() => {
    setPageNum(1)
    getProductList()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText, imageId, filter])

  async function getProductList() {
    setPageLoading(true)
    const params = {
      country,
      pageSize: 20,
      pageNum: pageNumRef.current,
      ...filter,
    }

    let getProductListApi
    // 搜图或者搜文本
    if (imageId) {
      params.imageId = imageId
      getProductListApi = thirdApi.getProductListByImage
    } else {
      params.keyword = searchText
      getProductListApi = thirdApi.getProductListByKeyword
    }
    const [err, res] = await to(getProductListApi(params))

    setPageLoading(false)

    if (err) {
      setProductList([])
      setNoData(true)
      return
    }

    const { data: list, code } = res

    let totalList = []
    if (pageNumRef.current === 1) {
      totalList = list || []
    } else {
      totalList = productList.concat(...(list || []))
    }
    setNoData(!totalList.length)
    setProductList(totalList)
    setExtend(res.extend || {})

    if (
      // (Array.isArray(list) && pageNumRef.current >= 5) ||
      err ||
      (code === 0 && !list)
    ) {
      setHasMore(false)
    } else {
      setHasMore(true)
    }
  }

  async function loadMore() {
    setPageNum(pageNum + 1)
    await getProductList()
  }

  useEffect(() => {
    if (refMasonry.current) {
      const offset = window.getComputedStyle(refMasonry.current)

      setCellWidth(
        `calc(${window.screen.width / 2}px - ${offset.paddingLeft} - ${px2rem(
          8,
        )})`,
      )
    }
  }, [])

  return (
    <div className={styles['product-wrap']}>
      {(pageLoading || noData) && (
        <div className={styles['full-page-wrap']}>
          {pageLoading && (
            <DotLoading color="#FF5100" className={styles['dot-loading']} />
          )}
          {noData && (
            <div className={styles['no-data']}>
              <img src={noDataImg} alt="" className={styles['no-data-img']} />
              <div>{t('没有找到相关商品')}</div>
            </div>
          )}
        </div>
      )}
      <div className={styles['product-bd']} ref={refMasonry}>
        <Masonry
          breakpointCols={breakpointColumnsObj}
          className={styles['my-masonry-grid']}
          columnClassName={styles['my-masonry-grid_column']}
        >
          {productList.map((item, index) => (
            <ProductCell1688
              item={item}
              extend={extend}
              index={index}
              key={index}
              cellWidth={cellWidth}
            />
          ))}
        </Masonry>
        {hasMore && (
          <InfiniteScroll
            threshold={350}
            loadMore={loadMore}
            hasMore={hasMore}
          />
        )}
      </div>
    </div>
  )
}

export default Products
